/*** IMPORTS FROM imports-loader ***/
(function() {

define([
        'jquery',
        'mustache',
        'pip-model',
        'pip-events'
    ],
    function (
        $,
        mustache,
        pip,
        pipEvents
    ) {
        var AR_HOST = 'https://assets.homedepot-static.com/mobile-apps/3d/usdz';
        var AR_GUID = '37d7e759-2f42-4f42-bf01-62ec7c66aa9e';

        var view = {
          selectors: {
            augmentedReality: '.augmented-reality',
            augmentedRealityBlock: '#augmented-reality__template',
            arButton: '.augmented-reality__button',
            arDrawer: '.augmented-reality-drawer',
            arDrawerContainer: '.augmented-reality-drawer__container',
            arDrawerContentBlock: '.augmented-reality-drawer__contentblock',
            arDrawerStatus: '.augmented-reality-drawer__status',
            arDrawerCloseButton: '.augmented-reality-drawer__closeicon',
            arDrawerCloseButtonBlock: '.augmented-reality-drawer__closeblock',
            arMask: '.augmented-reality-drawer__open',
            arViewerButton: '.augmented-reality-drawer__viewer',
            arMediaGallery: '.media'
          },
          classes: {
            loadingComplete: 'augmented-reality-drawer__status--done',
            loader: 'segment-spinner',
            arDrawerOpen: 'augmented-reality-drawer__open',
            arDrawerContainerOpen: 'augmented-reality-drawer__container--open',
            arDrawerContainerClose: 'augmented-reality-drawer__container--closed',
            arDrawerContentReady: 'augmented-reality-drawer__contentblock--ready',
            arDrawerMask: 'augmented-reality-drawer__body--noscroll',
            arDrawerStack: 'augmented-reality-drawer__stack'
          },
          templates: {
            augmentedReality: $('#augmented-reality__template').html(),
          },
          render: {
            renderArTemplate: function renderArTemplate() {
              return mustache.render(view.templates.augmentedReality, viewModel);
            }
          },
          updateDOM: {
            updateArDOM: function updateArDOM() {
              $(view.selectors.augmentedReality).html(view.render.renderArTemplate())
            }
          },
          initDOMEventListeners: function () {
            $(view.selectors.arButton).on('click', function(e) {
              openDrawer();
            });

            $(view.selectors.arDrawerCloseButton + "," + view.selectors.arDrawer + "," + view.selectors.arViewerButton).on('click', function(e) {
              e.stopPropagation();
              closeDrawer();
            });

            $(view.selectors.arDrawerContentBlock).on('click', function(e) {
              e.stopPropagation();
              return false;
            });
            $(view.selectors.arViewerButton).on('touchstart', function(e) {
              if (e && e.currentTarget) {
                e.currentTarget.click();
              }
            });
          }
        };

        var viewModel = {
          assetLink: function assetLink() {
            var attributeGroups = pip.products
              && pip.products.primary
              && pip.products.primary.data
              && pip.products.primary.data.attributeGroups;

            var usdzLink = viewModel.getARLink(attributeGroups);
            if (!usdzLink) return null;
            return AR_HOST + "/" + usdzLink;
          },
          isDeviceARCompatible: function isDeviceARCompatible() {
            if (typeof window !== 'undefined') {
              var a = window.document.createElement('a');
              if (a && a.relList && a.relList.supports('ar')) {
                return true;
              }
            }
            return false;
          },
          getGroupEntries: function getGroupEntries(attributeGroups, groupType) {
            var group = (attributeGroups || [])
              .filter(function(eachProp) {
                return eachProp.groupType === groupType
              })
            group = group.length ? group.shift() : null;
            return group && group.entries ? group.entries : [];
          },
          getUSDZ: function getUSDZ(augmentedRealityJson) {
            var usdz = augmentedRealityJson['3D']
              && augmentedRealityJson['3D'].usdz
              && augmentedRealityJson['3D'].usdz.length
              ? augmentedRealityJson['3D'].usdz[0]
              : '';
            return usdz;
         },
          getARLink: function getARLink(attributeGroups) {
           var skuAttributeGroups = viewModel.getGroupEntries(attributeGroups, 'notDisplayed');
           var augmentedRealityLink = (skuAttributeGroups || []).filter(function(entry) {
             return entry.guid === AR_GUID
           });
           augmentedRealityLink = augmentedRealityLink.length ? augmentedRealityLink.shift() : null;
           var arLinkValue = augmentedRealityLink ? augmentedRealityLink.value : '';
           var augmentedRealityJson = {};
           if (arLinkValue && typeof arLinkValue === 'string') {
             augmentedRealityJson = JSON.parse(arLinkValue);
           }
           return viewModel.getUSDZ(augmentedRealityJson);
         }
        }

        function preventTouchMove(e) {
          e.preventDefault();
        };

        function openDrawer() {
          getDrawerReady(true);
          $(view.selectors.arDrawer).addClass(view.classes.arDrawerOpen);
          $(view.selectors.arDrawerContainer).addClass(view.classes.arDrawerContainerOpen);
          $(view.selectors.arDrawerContentBlock).addClass(view.classes.arDrawerContentReady);
          $(view.selectors.arButton).closest(view.selectors.arMediaGallery).addClass(view.classes.arDrawerStack);
          document.body.classList.add(view.classes.arDrawerMask);
          document.body.addEventListener("touchmove", preventTouchMove, { passive: false });
        }

        function closeDrawer() {
          getDrawerReady(false);
          $(view.selectors.arDrawer).removeClass(view.classes.arDrawerOpen);
          $(view.selectors.arDrawerContainer).removeClass(view.classes.arDrawerContainerOpen);
          $(view.selectors.arButton).closest(view.selectors.arMediaGallery).removeClass(view.classes.arDrawerStack);

          document.body.classList.remove(view.classes.arDrawerMask);
          document.body.removeEventListener("touchmove", preventTouchMove);
        }

        function getDrawerReady(isContentReady) {
          $(view.selectors.arViewerButton).hide();
          if (isContentReady) {
            setTimeout(function() {
              handleSpinner(isContentReady);
            }, 1500);
          } else {
            handleSpinner(isContentReady);
          }
        }

        function handleSpinner(isContentReady) {
          if (isContentReady) {
            $(view.selectors.arDrawerStatus).removeClass(view.classes.loader).addClass(view.classes.loadingComplete);
            $(view.selectors.arViewerButton).show();
          } else  {
            $(view.selectors.arDrawerStatus).removeClass(view.classes.loadingComplete).addClass(view.classes.loader);
            $(view.selectors.arViewerButton).hide();
          }
        }

        function shouldArBeDisplayed() {
          var attributeGroups = pip.products
            && pip.products.primary
            && pip.products.primary.data
            && pip.products.primary.data.attributeGroups;

          return pip.features.augmentedRealityEnabled
            && viewModel.isDeviceARCompatible()
            && !!viewModel.getARLink(attributeGroups);
        }

        function initAppEventListeners() {
          $(window.document).off('click', view.selectors.arButton);
          $(window.document).on('click', view.selectors.arButton, function(e){
              pipEvents.augmentedReality.augmentedRealityDrawerActivated.trigger();
          });
        }

        return {
          init: function () {
            if(shouldArBeDisplayed()) {
              view.updateDOM.updateArDOM();
              view.initDOMEventListeners();
              initAppEventListeners();
            }
          },
          view: view,
          viewModel: viewModel
        }
    })

}.call(window));